// Référence de commande lisible basée sur la date/heure de création.
// ponytail: affichage uniquement — l'id DB reste la clé partout (FK, recherche, routes).
// Collision possible si 2 commandes dans la même minute ; ajouter les secondes si ça gêne.
export const formatOrderRef = (order) => {
    const d = new Date(order?.created_at || order?.orderDate);
    if (isNaN(d.getTime())) return `#${order?.id}`;
    const p = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}-${p(d.getHours())}${p(d.getMinutes())}`;
};
